import { useCallback, useEffect, useRef, useState } from 'react'
import BaseMobileAppContainer from '../base-mobile-app-container/BaseMobileAppContainer'
import { APP_KEY_IDS } from '../../../constants/constants'
import Styles from "./Camera.module.scss";
import { ReactComponent as CapctureIcon } from "../../../icons/app/capture.svg"
import { ReactComponent as FlipIcon } from "../../../icons/extra_icons/smasung_camera_flip.svg"
import { ReactComponent as SettingsIcon } from "../../../icons/extra_icons/samsung_settings_mini.svg"
import { ReactComponent as FlashIcon } from "../../../icons/extra_icons/samsung_camera_flash.svg"
import { ReactComponent as FilterIcon } from "../../../icons/extra_icons/samsung_camera_filter.svg"


import RatioIcon from "../../../icons/extra_icons/samsung_camera_ratio.png"
import MotionIcon from "../../../icons/extra_icons/samsung_motion.png"

import classnames from "classnames"
// import { macLibraryImages } from '../../gallery/Gallery';


//Redux
import { openWindow } from '../../../actions';
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import NavigationBar from '../navigation-bar/NavigationBar';
import handleLibraryImages from '../../../reducers/gallery';
import { addImage } from '../../../actions/gallery';
import Webcam from 'react-webcam';


interface CameraModesTypes{
    [key:string]: ModeTypes;
}

interface ModeTypes{
    id:number;
    label:string;
}

const Camera = () => {

    const [activeCamerMode,setActiveCameraMode]=useState(2)

    const macLibraryImages = useSelector((State:RootStateOrAny)=>State.handleLibraryImages)

    const webcamRef = useRef<any>(null);

    const capture = useCallback(() => {
        if (webcamRef.current != null) {
            const imageSrc = webcamRef.current.getScreenshot();
            dispatch(addImage(imageSrc))
            setImg(imageSrc);
        }
    }, [webcamRef]);
    
    const pictureClickTypes = [
        {
            id: 0,
            icon: <CapctureIcon />
        },
        {
            id: 1,
            icon: <CapctureIcon />
        },
        {
            id: 2,
            icon: <CapctureIcon />
        }
    ]


    const CameraModes:CameraModesTypes = {
        "potrait": {
            id: 0,
            label: "Potrait",
        },
        "pro": {
            id: 1,
            label: "Pro",
        },
        "photo": {
            id: 2,
            label: "Photo",
        },
        "video": {
            id: 3,
            label: "Video",
        },
        "more": {
            id: 4,
            label: "More",
        }
    }



    const [img, setImg] = useState("")

    useEffect(() => {
        streamCamVideo()
    }, [])

    const dispatch = useDispatch()
    const streamCamVideo = () => {
        var constraints = { audio: false, video: { width: 1280, height: 1080 } };
        navigator.mediaDevices
            .getUserMedia(constraints)
            .then(function (mediaStream) {
                var video = document.querySelector("video");

                if (video != null) {
                    video.srcObject = mediaStream;
                    video.onloadedmetadata = function (e) {
                        video?.play();
                    };
                }
            })
            .catch(function (err) {
                console.log(err.name + ": " + err.message);
            }); // always check for errors at the end.
    }

    const handleCameraModeClick=(modeType:number)=>{
        setActiveCameraMode(modeType)
    }


    return (
        <div className={Styles.camera_content}>
            <div className={Styles.top_sheet}>
                <div className={Styles.icon}>
                    <SettingsIcon />
                </div>
                <div className={Styles.icon}>
                    <FlashIcon />
                </div>
                <div className={Styles.icon}>
                    <img src={RatioIcon} />
                </div>
                <div className={Styles.icon}>
                    <img src={MotionIcon} />
                </div>
                <div className={Styles.icon}>
                    <FilterIcon />
                </div>
            </div>
            {/* <video className={Styles.video_stream} autoPlay={true} id="videoStream" /> */}
            <Webcam className={Styles.video_stream}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                    />
            <div className={Styles.bottom_sheet}>
                <div className={Styles.camera_modes} style={{marginLeft:`${
                    activeCamerMode>Object.keys(CameraModes).length/2 ? `-${(activeCamerMode-Object.keys(CameraModes).length/2)*65}px` : `${(Object.keys(CameraModes).length/2-activeCamerMode)*65}px`
                }`}}>
                    {
                        Object.keys(CameraModes).map((mode: string) => {
                            return (
                                <div key={CameraModes[mode].id} className={classnames(Styles.mode,CameraModes[mode].id===activeCamerMode && Styles.active_camera_mode)} onClick={()=>{handleCameraModeClick(CameraModes[mode].id)}}>
                                    {CameraModes[mode].label}
                                </div>
                            )
                        })
                    }
                </div>

                <div className={Styles.main_ctas}>
                    <div className={Styles.captured_image} onClick={() => { dispatch(openWindow((APP_KEY_IDS.MOBILE_GALLERY))) }} >
                        <img src={img || macLibraryImages[Object.keys(macLibraryImages)[0]]} alt="gallery_image" />
                    </div>
                    <div className={Styles.cta} onClick={capture}>
                        <div className={classnames(Styles.button, activeCamerMode===3 ? Styles.video : Styles.photo)} />
                    </div>
                    <div className={Styles.change_camera}>
                        <FlipIcon />
                    </div>
                </div>
            </div>
            <NavigationBar forceDarkMode={true} appId={APP_KEY_IDS.MOBILE_CAMERA}/>
        </div >
    )
}

export default Camera
